import { useTheme, Popover as MUIPopover } from '@mui/material';
import React from 'react';
import { IRecordHeaders } from 'ui-component/records/types';
import { HierarchyQuickView } from '../../HierarchyQuickView';

export type PopoverProps = {
    open: boolean;
    anchorEl: HTMLElement | null;
    onClose: () => void;
    record: IRecordHeaders;
    onViewFullHierarchy: () => void;
    anchorOrigin?: {
        vertical: 'top' | 'bottom' | 'center';
        horizontal: 'left' | 'center' | 'right';
    };
    transformOrigin?: {
        vertical: 'top' | 'bottom' | 'center';
        horizontal: 'left' | 'center' | 'right';
    };
};
export const Popover = ({ open, anchorEl, onClose, record, onViewFullHierarchy, anchorOrigin, transformOrigin }: PopoverProps) => {
    const { palette } = useTheme();
    return (
        <MUIPopover
            PaperProps={{
                elevation: 0,
                sx: {
                    width: '405px',
                    minHeight: '108px',
                    borderRadius: '8px',
                    border: 'solid 1px',
                    borderColor: palette.primary[500]
                }
            }}
            open={open}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left', ...anchorOrigin }}
            transformOrigin={{ vertical: 'top', horizontal: 'left', ...transformOrigin }}
        >
            <HierarchyQuickView record={record} onOpenFullHierarchy={onViewFullHierarchy} />
        </MUIPopover>
    );
};
